<template>
  <v-main style="min-height: 70vh" v-if="company !== null">
    <MainMenu v-if="currentUser === null" />
    <v-container
      :class="
        currentUser === null
          ? 'responsive-public-template-content'
          : 'responsive-template-content'
      "
    >
      <v-row dense justify="space-around" class="ma-2">
        <v-row>
          <ViewJobOffer
            :display-dialog="displayJobOffer"
            :job-offer="jobOfferToView"
            v-if="renderViewJobModal"
            :hideModalComponentCallback="hideModalComponent"
            v-bind:display-save-button-props="true"
          />
        </v-row>

        <v-card min-width="100%">
          <v-img
            height="150px"
            :src="companyCoverPicture"
            alt="Photo de couverture de l'entreprise"
          >
            <v-app-bar flat color="rgba(0, 0, 0, 0)">
              <v-spacer></v-spacer>
            </v-app-bar>

            <v-card-title class="white--text"> </v-card-title>
          </v-img>
          <v-avatar size="90" class="profile mt-5 ml-5" tile>
            <img alt="Logo de l'entreprise" :src="companyLogo" />
          </v-avatar>
          <span class="ml-3 font-weight-bolder text-h4">{{
            company.name
          }}</span>
          <v-card-text>
            <v-tabs v-model="tab">
              <v-tabs-slider color="blue"></v-tabs-slider>
              <v-tab v-for="item in items" :key="item">
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :key="items[0]">
                <v-card flat>
                  <v-card-title class="text-h5 font-weight-light">
                    A propos de l'entreprise</v-card-title
                  >
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card elevation="1">
                          <v-card-subtitle class="font-weight-bold">
                            Année de création</v-card-subtitle
                          >
                          <v-card-text>
                            {{ company.companyCreationDate }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card elevation="1">
                          <v-card-subtitle class="font-weight-bold">
                            Taille de l'entreprise</v-card-subtitle
                          >
                          <v-card-text>
                            {{ company.companySize }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card elevation="1">
                          <v-card-subtitle class="font-weight-bold">
                            Secteur d'activité</v-card-subtitle
                          >
                          <v-card-text>
                            {{
                              company.sector !== null ? companySector.name : ""
                            }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card elevation="1">
                          <v-card-subtitle class="font-weight-bold">
                            Site web
                          </v-card-subtitle>
                          <v-card-text>
                            <a :href="company.websiteUrl" target="_blank">{{
                              company.websiteUrl
                            }}</a>
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-card elevation="1">
                          <v-card-subtitle class="font-weight-bold">
                            Numéro de téléphone
                          </v-card-subtitle>
                          <v-card-text>
                            {{ company.phoneNumber }}
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" v-html="company.profileDescription">
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :key="items[1]">
                <v-card flat class="ma-6" v-html="company.whyToApply"> </v-card>
              </v-tab-item>
              <v-tab-item :key="items[2]">
                <v-card flat>
                  <v-card-title class="font-weight-light">
                    {{ jobOffersListElements.length }} offres d'emplois
                    disponibles</v-card-title
                  >
                  <v-card-text>
                    <v-row class="pa-3">
                      <v-col cols="12">
                        <v-list two-line elevation="1" light>
                          <v-list-item-group v-model="selected" multiple>
                            <template
                              v-for="(item, index) in updateVisibleJobs"
                            >
                              <v-list-item
                                color="white"
                                :key="`${item.title}${Math.floor(
                                  Math.random() * 100000
                                )}`"
                                style="width: 100%"
                                v-on:click="viewJobOffer(item.id)"
                              >
                                <template>
                                  <v-list-item-content>
                                    <v-list-item-title
                                      v-text="item.title"
                                      style="color: black"
                                    ></v-list-item-title>

                                    <v-list-item-subtitle
                                      style="color: #1565c0"
                                      class="font-weight-medium"
                                      v-text="item.headline"
                                    ></v-list-item-subtitle>

                                    <v-list-item-subtitle
                                      v-html="
                                        `${item.subtitle.substr(0, 50)} ...`
                                      "
                                    ></v-list-item-subtitle>
                                  </v-list-item-content>

                                  <v-list-item-action>
                                    <v-list-item-action-text
                                      v-text="item.action"
                                    ></v-list-item-action-text>
                                  </v-list-item-action>
                                </template>
                              </v-list-item>
                              <v-divider
                                v-if="index < jobOffers.length - 1"
                                :key="index"
                                inset
                                style="
                                  color: #6b6868;
                                  margin-left: 0px;
                                  max-width: 100% !important;
                                "
                              ></v-divider>
                            </template>

                            <v-pagination
                              v-model="page"
                              :length="
                                Math.ceil(
                                  jobOffersListElements.length / perPage
                                )
                              "
                              circle
                            >
                            </v-pagination>
                          </v-list-item-group>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-row>
    </v-container>
    <Footer v-if="currentUser === null" />
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import ViewJobOffer from "@/components/Candidate/ViewJobOffer";
import { timeSince } from "@/helper/DateTimeHelper";
import Footer from "@/components/common/Footer";
import MainMenu from "@/components/common/MainMenu";

export default Vue.extend({
  name: "ViewCompanyPage",
  components: { MainMenu, Footer, ViewJobOffer },
  data: function () {
    return {
      currentUser: null,
      tab: null,
      items: ["A propos", "Pourquoi postuler", "Emplois"],
      company: null,
      companySector: "",
      jobOffers: null,
      jobOffersListElements: [],
      companyLogo: "",
      companyCoverPicture: "",
      page: 1,
      perPage: 5,
      displayJobOffer: false,
      jobOfferToView: null,
      selected: [2],
      renderViewJobModal: false,
    };
  },
  mounted() {
    this.currentUser = localStorage.getItem("currentUser");
    this.fetchCompany();
  },
  computed: {
    updateVisibleJobs: function () {
      return this.jobOffersListElements.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  watch: {
    jobBoardJobModel(val) {
      if (val != null) this.tab = 0;
      else this.tab = null;

      if (val.length > 0) {
        this.searchJob();
      }
    },
    search(val) {
      // Items have already been loaded
      if (this.items.length > 0 && val) {
        const result = this.items.filter(
          (value) =>
            value.name.toLowerCase() === val.toLowerCase() ||
            value.name.toLowerCase().search(val.toLowerCase()) !== -1
        );
        if (result.length > 0) {
          return;
        }
      }
    },
  },
  methods: {
    viewJobOffer: function (offerId) {
      const offer = this.jobOffers.filter((elt) => elt.id === offerId);
      if (offer.length !== 1) {
        alert("une erreur s'est produite");
      } else {
        this.jobOfferToView = offer[0];
        this.displayJobOffer = true;
        this.renderViewJobModal = true;
      }
    },
    hideModalComponent: function () {
      this.renderViewJobModal = false;
    },

    fetchCompany() {
      const httpClient = new HttpClient();
      console.log(this.$route.params.companyId);
      httpClient
        .getCompany(parseInt(this.$route.params.companyId))
        .then((res) => {
          this.company = res.data.company;
          this.jobOffers = res.data.jobOffers;
          res.data.jobOffers.map((elt) => {
            this.jobOffersListElements.push({
              id: elt.id,
              action: timeSince(new Date(elt.createdAt)),
              headline: elt.company.name,
              subtitle: elt.description,
              title: elt.job.name + " - " + elt.type.name,
            });
          });
          let tmpLogo = "";
          let tmpCoverPicture = "";
          if (this.company.logo != null) {
            tmpLogo = this.company.logo.fileName;
          }
          if (this.company.coverPicture != null) {
            tmpCoverPicture = this.company.coverPicture.fileName;
          }
          this.companyLogo = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/company/logo/${tmpLogo}`;
          this.companyCoverPicture = `${process.env.VUE_APP_JOB_BOARD_API_ENDPOINT}/uploads/company/cover_pictures/${tmpCoverPicture}`;
          this.companySector = this.company.sector;
          console.log(res.data);
        })
        .catch((error) => {
          console.error(error);
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else if (error.response.status === 404) {
            this.$router.push({ name: "not_found" });
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
  },
});
</script>

<style scoped></style>
